
export const VisualElements = {
  headline: 'Título',
  actionButton: 'Botão de Ação',
  autoplay: 'Reprodução Automática',
  logo: 'Logo',
  thumbnail: 'Thumbnail',
  pauseOverlay: 'Overlay de Pausa',
  continueWatching: 'Continuar de onde parou',
  progressBar: 'Barra de Progresso',
  playbackControls: 'Controles do Player',
  controls: 'Controles',
  audience: 'Audiência',
  audienceSimulation: 'Audiência Simulada',
  border: 'Borda',
  repeatVideo: 'Repetir Vídeo',
  affiliate: 'Afiliado',
  salesNotification: 'Notificação de Vendas',
  notificationPosition: 'Posição da Notificação',
  selectWhereToShow: 'Escolha onde exibir no vídeo',
  testNotificationNow: 'Testar notificação agora',
  showControls: 'Mostrar Controles',
  skipForwardButton: 'Avançar 10s',
  volumeControl: 'Controle de Volume',
  showCurrentTime: 'Mostrar Tempo',
  fullScreen: 'Tela Cheia',
  rewind: 'Retroceder 10s',
  smallPlayButton: 'Botão Play Pequeno',
  customIcon: 'Ícone Personalizado',
  playerColors: 'Cores do Player',
  primaryColor: 'Cor Primária',
  secondaryColor: 'Cor Secundária',
};
